module.exports = __webpack_public_path__ + "static/media/eps.6c896ffd.svg";